import shopifyLogo from "@/assets/images/integrations/shopify-sm.png";
import westoreLogo from "@/assets/images/integrations/westore.png";
import woocommerceLogo from "@/assets/images/integrations/woocommerce-channel.png";
import wixLogo from "@/assets/images/integrations/wix.png";
import sallaLogo from "@/assets/images/integrations/marketplaces/salla.webp";
import amazonLogo from "@/assets/images/integrations/marketplaces/amazon-ae.png";
import noonLogo from "@/assets/images/integrations/marketplaces/noon.jpg";
import zidLogo from "@/assets/images/integrations/marketplaces/zid.png";
import moment from "moment";
export const channels = {
  data() {
    return {
      channels: {
        shopify: shopifyLogo,
        woocommerce: woocommerceLogo,
        "WeStore Api": westoreLogo,
        WeStore: westoreLogo,
        wix: wixLogo,
        salla: sallaLogo,
        amazon: amazonLogo,
        noon: noonLogo,
        zid: zidLogo,
      },
    };
  },
  watch: {
    currentPage: function (newCurrentPage, oldCurrentPage) {
      if (newCurrentPage > oldCurrentPage) {
        this.paginateStart = (newCurrentPage - 1) * this.perPage + 1;
      } else if (newCurrentPage === 1) {
        this.paginateStart = newCurrentPage;
      } else {
        this.paginateStart = (newCurrentPage - 1) * this.perPage + 1;
      }

      this.fetchData();
    },
  },
  methods: {
    detectChannel(marketplace) {
      return marketplace ? this.channels[marketplace] : westoreLogo;
    },
    convertDate: function (timestampValue, format = "DD/MM/YYYY") {
      return moment.unix(timestampValue).format(format);
    },
    detectStatus(status) {
      switch (status) {
        case "Initiated":
          return "initiated-badge";

        case "Cancelled":
        case "Out of Stock":
        case "Returned":
          return "canceled-badge";

        case "Sent To Warehouse":
          return "badge-soft-primary";

        case "Processing":
        case "Dispatched From Warehouse":
        case "Picked For Delivery":
        case "Out For Delivery":
        case "Delivered":
        case "Shipped":
          return "processing-badge";

        case "In Stock":
          return "badge-soft-success";

        case "In Transit":
          return "transit-badge";

        case "On Hold":
          return "on-hold-badge";

        case "RTO":
          return "RTO-badge";

        case "Received":
        case "Picked & Packed":
        case "Arrived":

          return "delivered-badge";

        case "Wrong Address":
        case "Unreachable":
        case "Address Changed":
        case "Customer Re-scheduled":
        case "Unsuccessful Pickup":
        case "Customer Rejected":
          return "wrong-address-badge";

        case "First Delivery Attempt":
        case "Second Delivery Attempt":
        case "Third Delivery Attempt":
        case "In-transit":
          return "delivery-attempt-badge";
        default:
          break;
      }
    },
    ToTimeStamp(date) {
      return Date.parse(date) / 1000;
    },
  },
};
